export default __webpack_public_path__ + "static/media/0016.51d82c08.WAV";